// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as Illustration } from './Illustration.vue'

// The illustration frame — a consistent, responsive box for a brand
// illustration (an inline SVG via the default slot, or a raster via `src`). It
// owns sizing / aspect / a11y so illustrations scale uniformly; the
// name → asset RESOLUTION is deliberately NOT here — that pipeline (the KUI
// `illustrations-*` SVG registry) moves to a DS-consumable home as its own
// workstream (ROADMAP icon-system decision, 2026-07-19). Distils
// KUICoreIllustration's presentation role; `filled` and the raw asset map stay
// with the pipeline. Decorative by default; pass `alt` for a meaningful image.
export const illustrationVariants = cva(
  'inline-flex shrink-0 items-center justify-center [&>svg]:size-full [&>img]:size-full [&>img]:object-contain',
  {
    variants: {
      size: {
        sm: 'size-16',
        md: 'size-24',
        lg: 'size-40',
        xl: 'size-64',
        auto: '',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)
export type IllustrationVariants = VariantProps<typeof illustrationVariants>
